import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { DrawerContext, ModalModel } from '@notino/react-styleguide';

import { StyledHeader } from '@sharedComponents/AddToCartButton/AddToCartModal/styled';
import messages from '@sharedComponents/AddToCartButton/messages';
import { IAddToCartButtonProps } from '@sharedComponents/AddToCartButton/model';
import { NotificationModalOrDrawerContent } from '@sharedComponents/AddToCartButton/NotificationModal';

import { MaxProductsInCartModal } from './MaxProductsInCartModal';

// Lazy-loaded to break the static circular dependency:
// BuyButton → AddToCartButton → getModalAfterAddToCart → AddToCartModal → UpsellingList → BuyButton
const AddToCartModal = React.lazy(() =>
  import('@sharedComponents/AddToCartButton/AddToCartModal').then((m) => ({
    default: m.AddToCartModal,
  }))
);

export const getModalAfterAddToCart: IAddToCartButtonProps['getModalAfterAddToCart'] =
  (props) => {
    if (props.type === 'common' && props.notification?.modalType === 'common') {
      return [
        <NotificationModalOrDrawerContent
          key="notification"
          statusMessages={props.notification.messages}
          messagesValues={props.notification.values}
        />,
        {
          center: false,
          withFocusTrap: true,
          header: (
            <StyledHeader>
              <FormattedMessage {...messages[props.notification.header]} />
            </StyledHeader>
          ),
        },
        {
          header: (
            <StyledHeader>
              <FormattedMessage {...messages[props.notification.header]} />
            </StyledHeader>
          ),
        },
      ];
    } else if (props.type === 'upselling') {
      return [
        <DrawerContext.Provider key="upselling">
          <React.Suspense
            fallback={<button style={{ opacity: 0 }} />} // invisible button to make FocusTrap happy
          >
            <AddToCartModal
              products={props.products}
              response={props.response}
              closingModal={props.onClosingModal}
              services={props.services}
            />
          </React.Suspense>
        </DrawerContext.Provider>,
        {
          center: false,
          onClose: props.onClose,
          size: ModalModel.ModalSizes.large,
          withFocusTrap: true,
          noBorders: true,
          disableCloseButton: true,
        },
        {
          noHeaderHandle: true,
          header: (
            <StyledHeader>
              <FormattedMessage {...messages.addedToCart} />
            </StyledHeader>
          ),
        },
      ];
    } else if (props.type === 'maxProductsInCart') {
      return [
        <MaxProductsInCartModal key="maxProductsInCart" />,
        {
          withFocusTrap: true,
        },
        {},
      ];
    }
    return undefined!;
  };
